import { useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

import { useEffect } from "react";

import PatientReport from "./patientReport";
import { useStore } from "../store";

const DocumentView = () => {
  let navigate = useNavigate();
  const { documentId } = useParams();
  const selectedPatient = useStore((state) => state.patient);
  const [isLoading, setLoading] = useState(false);


  const handleGoBack = () => {
    navigate(-1);
  };


  return (
    <div className="bg-gray-50 min-sh-screen">
      <div className="flex justify-between text-black p-4 pt-6 h-16 fixed max-w  z-50 w-full bg-gray-50 ">
        <div>
          <Link className="flex" onClick={handleGoBack}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="2"
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
              />
            </svg>
            <div className="pl-2 flex-1 mt-0.5">
              <h4 className="font-semibold text-sm">Document</h4>
            </div>
          </Link>
        </div>
      </div>
      <div className=" flex-1 overflow-scroll hideScroll  text-gray-500flex flex-col pt-16 p-4">
        <div className="flex flex-col h-[calc(100vh-90px)]">
          {isLoading && (
            <>
              <div className="animate-pulse h-full flex flex-col  w-full  items-center  bg-gradient-to-r from-white to-zinc-100  ">
                <div className="w-full h-2/5 bg-slate-200 mb-4"></div>
                <div className="w-full  bg-slate-200 h-5 my-1"></div>
                <div className="w-full  bg-slate-200 h-5 my-1"></div>
                <div className="w-full  bg-slate-200 h-5 my-1"></div>
                <div className="w-full  bg-slate-200 h-5 my-1"></div>
                <div className="w-full  bg-slate-200 h-5 my-1"></div>
                <div className="w-full  bg-slate-200 h-5 my-1"></div>
                <div className="w-[260px]  bg-slate-200 h-9 rounded-2xl mt-5"></div>
              </div>
            </>
          )}
          {!isLoading && (
            <>
             <PatientReport documentId={documentId} consumerId={selectedPatient.id} style={{height:'calc(100vh - 90px)',scrollbarWidth: 'none'}}/>
            </>
          )}
        </div>
        
      </div>
    </div>
  );
};

export default DocumentView;
